import { api } from '@/lib/api'

export interface ProfileData {
  // Dados básicos
  email?: string
  name?: string
  username?: string
  bio?: string
  avatarUrl?: string
  
  // Dados pessoais
  phone?: string
  cpf?: string
  city?: string
  state?: string
  profession?: string
  
  // Dados do questionário
  profileType?: string
  howKnew?: string
  aiFamiliarity?: string
  
  // Dados de propriedade (produtor)
  propertySizeHa?: number
  biome?: string
  soilType?: string
  propertyCity?: string
  propertyState?: string
  productionSystem?: string
  gaasAssociated?: string
  activities?: string[]
  practices?: string[]
  challenges?: string[]
  mainObjective?: string
  
  // Dados profissionais (técnico/consultor)
  professionalFormation?: string
  workArea?: string
  workRegion?: string
  workType?: string
  regenerativeExperience?: string
  experienceYears?: string
  
  // Dados acadêmicos (pesquisador/estudante)
  institution?: string
  workField?: string
  mainInterest?: string
  preferredTopics?: string[]
  
  // Observações gerais
  observations?: string

  // Consentimento de dados
  dataSharingConsent?: string
  
  // Dados legais
  termsAcceptedAt?: string
  termsVersion?: string
  termsAcceptedIP?: string
  termsAcceptedUserAgent?: string
  privacyAcceptedAt?: string
  privacyVersion?: string
}

export interface User {
  id: string
  email: string
  name: string
  username?: string
  bio?: string
  avatarUrl?: string
  role: string
  status: string
  phone?: string
  cpf?: string
  city?: string
  state?: string
  profession?: string
  profileType?: string
  createdAt: string
}

export const profileService = {
  // Obter perfil do usuário atual
  async getProfile(): Promise<{ user: User }> {
    const response = await api.get('/auth/profile')
    return response.data
  },

  // Atualizar perfil do usuário
  async updateProfile(data: ProfileData): Promise<{ user: User; message: string }> {
    const response = await api.put('/auth/profile', data)
    return response.data
  }
}
